import React from "react";
import ServiceCard from "../cards/ServiceCard";

const services = [
  {
    title: "Residential Construction",
    desc: "Custom homes, villas, and upgrades delivered with quality workmanship and practical planning.",
    icon: "bi bi-house-door",
    color: "#352672",
  },
  {
    title: "Commercial Projects",
    desc: "Office, retail, and business spaces planned for function, appearance, and long-term use.",
    icon: "bi bi-building",
    color: "#352672",
  },
  {
    title: "Industrial Projects",
    desc: "Industrial sites built for durability, safer operations, and dependable day-to-day performance.",
    icon: "bi bi-gear-wide-connected",
    color: "#352672",
  },
  {
    title: "Renovation And Remodeling",
    desc: "Upgrades for existing spaces that improve layout, finish quality, and everyday usability.",
    icon: "bi bi-tools",
    color: "#352672",
  },
  {
    title: "Project Management",
    desc: "Planning, coordination, and site supervision to keep projects organized and on schedule.",
    icon: "bi bi-clipboard-data",
    color: "#352672",
  },
  {
    title: "Maintenance Support",
    desc: "Repair and upkeep services that help homes and business spaces stay in good condition.",
    icon: "bi bi-palette2",
    color: "#352672",
  },
];

const ServicesSection: React.FC = () => (
  <section id='services' className='container my-5 py-2'>
    <h3 className='text-center website-section-title'>Our Services</h3>
    <p className='text-center website-section-subtitle mb-4'>
      Construction and maintenance services shaped around your property type,
      budget, timeline, and site requirement.
    </p>
    <div className='row g-4'>
      {services.map((service) => (
        <ServiceCard key={service.title} {...service} />
      ))}
    </div>
  </section>
);

export default ServicesSection;
